import { useMemo } from 'react';

import { generateHubBrandPalette } from './generate-hub-brand-palette';
import type { HubBrandPalette, HubBrandPaletteInputs } from './types';

/**
 * React hook returning a memoised 20-shade `HubBrandPalette` derived from a
 * (primary, accent) brand colour pair. Recomputes only when either input
 * colour changes. Pure render — SSR-safe.
 */
export const useHubBrandPalette = (inputs: HubBrandPaletteInputs): HubBrandPalette => {
	const { primary, accent } = inputs;
	return useMemo(() => generateHubBrandPalette({ primary, accent }), [primary, accent]);
};
